import { render, staticRenderFns } from "./UpdateRMN.vue?vue&type=template&id=31841587"
import script from "./UpdateRMN.vue?vue&type=script&lang=js"
export * from "./UpdateRMN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports